import { useState } from "react";
import { Loader2, Tags } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatApiError } from "@/lib/api";
import { download } from "@/lib/wh";

const FORMATS = [["small", "Piccola 50×30 mm", "Una per pagina, stampanti per etichette"], ["medium", "Media 70×40 mm", "Una per pagina, stampanti per etichette"], ["a4", "Foglio A4 – 24 etichette 70×37 mm", "Fogli adesivi per stampante normale"]];

export function LabelDialog({ open, onOpenChange, ids, wh = "mercatino" }) {
  const [fmt, setFmt] = useState("medium");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await download("/wh/labels", { wh, ids: ids.join(","), fmt }, "etichette.pdf"); onOpenChange(false); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="label-dialog">
        <DialogHeader><DialogTitle>Stampa etichette ({ids.length})</DialogTitle><DialogDescription>Logo, numero articolo, QR Code, codice a barre, prezzo e lotto.</DialogDescription></DialogHeader>
        <div className="space-y-2">
          {FORMATS.map(([k, l, d]) => (
            <label key={k} className={`flex gap-3 items-start rounded-xl border p-3 cursor-pointer ${fmt === k ? "border-[var(--primary)] bg-amber-50" : "border-[var(--border)]"}`}>
              <input type="radio" name="fmt" checked={fmt === k} onChange={() => setFmt(k)} className="mt-1" data-testid={`label-format-${k}`} />
              <span><span className="block text-sm font-semibold">{l}</span><span className="text-xs text-[var(--muted)]">{d}</span></span>
            </label>
          ))}
        </div>
        <button onClick={run} disabled={busy || !ids.length} className="btn-primary h-11 px-5 w-full" data-testid="label-download-button">{busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Tags className="h-5 w-5" />} Scarica etichette PDF</button>
      </DialogContent>
    </Dialog>
  );
}
